/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './OwnersRecordCard.module.scss';

import type { OwnersRecordCardProps } from './OwnersRecordCard.types';

const DIRECTORS: { name: string; role: string }[] = [
  { name: 'J. Smith', role: '(CEO)' },
  { name: 'M. Patel', role: '(CFO)' },
];

const UBOS: { name: string; pct: string }[] = [
  { name: 'J. Smith', pct: '75% ownership' },
  { name: 'R. Chen', pct: '25% ownership' },
];

export const OwnersRecordCard = ({ className }: OwnersRecordCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <span className={styles.avatar}>AT</span>
      <div>
        <div className={styles.name}>Acme Trading Ltd</div>
        <div className={styles.reg}>Ownership &amp; control</div>
      </div>
    </div>

    <div className={styles.body}>
      <div className={styles.cols}>
        <div>
          <div className={styles.k}>Directors</div>
          {DIRECTORS.map((person) => (
            <div key={person.name} className={styles.person}>
              <span className={styles.personDot} />
              {person.name}
              <span className={styles.personRole}>{person.role}</span>
            </div>
          ))}
        </div>

        <div>
          <div className={styles.k}>Ultimate Beneficial Owner</div>
          {UBOS.map((person) => (
            <div key={person.name} className={styles.person}>
              <span className={styles.personDot} />
              {person.name}
              <span className={styles.pct}>{person.pct}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.groupLabel}>Group Structure</div>
      <div className={styles.chain}>
        <span className={styles.chip}>Acme Holdings Plc</span>
        <span className={styles.sep}>›</span>
        <span className={cn(styles.chip, styles.chipHl)}>Acme Trading Ltd</span>
        <span className={styles.sep}>›</span>
        <span className={styles.chip}>2 subsidiaries</span>
      </div>
    </div>

    <div className={styles.source}>source: government registry record · shareholder filings</div>
  </div>
);
